<template>
  <div>
    <div
      style="
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
      "
    >
      <div style="flex: 8">
        <div>
          <a-list
            item-layout="vertical"
            size="large"
            :pagination="pagination"
            :data-source="listData"
          >
            <!-- <div slot="footer">底部</div> -->
            <a-list-item
              slot="renderItem"
              :key="item.id"
              slot-scope="item, index"
            >
              <a-list-item-meta @click="to_Detail(item.id)">
                <a slot="title">{{ item.title }}</a>
                <template slot="description">
                  <div style="height: 120px">{{ item.keywords }}</div>

                  <div>
                    <a-button size="small" type="link">{{
                      $t("新闻中心.新闻中心")
                    }}</a-button>
                    <span> {{ item.createTime }} </span>
                    <span key="like-o">
                      <a-icon type="star-o" style="margin-right: 8px" />
                      {{ item.thumbCount }}{{ $t("新闻中心.点赞") }}
                    </span>
                    <span key="eye">
                      <a-icon type="eye" style="margin-right: 8px" />
                      {{ item.browseCount }}{{ $t("新闻中心.浏览") }}
                    </span>
                  </div>
                </template>
                <a-avatar
                  size="large"
                  slot="avatar"
                  style="width: 200px; height: 200px"
                  :src="item.avatar"
                  shape="square"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </div>
      <div style="flex: 2; padding-left: 40px">
        <right-mode></right-mode>
      </div>
    </div>
  </div>
</template>

<script>
import RightMode from "../model/rightMode.vue";
import axios from "axios";

export default {
  components: { RightMode },
  data() {
    return {
      listData: [],
      loading: false,
      busy: false,
      mainOptions: {
        tableName: "jf_web_basicInfo",
        filters: {
          // x_开头起名的表示 or 查询
          // x_likelyFilter: [],
          queryFilter: [
            {
              dataIndex: "state",
              operator: "eq",
              value: 0,
            },
          ],
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc",
          },
        ],
        offset: 0,
        limit: 10,
      },
      pagination: {
        // simple: true,
        showSizeChanger: true, // 是否分页
        curPageSizeIndex: 0,
        pageSize: 5, // 每页记录数
        total: 0, // 总条数
        current: 1, // 当前显示页面

        // pageSizeOptions: ["5", "10"],
        showTotal: (total) => `共计 ${total}条`, // 显示总数
        // onShowSizeChange: (current, pagesize) => {
        //   this.pagination.current = current;
        //   this.pagination.pageSize = pagesize;
        //   this.mainOptions.offset = (current - 1) * pagesize;
        //   this.mainOptions.limit = pagesize;
        //   this.queryAction();
        // },
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.mainOptions.offset = (current - 1) * pageSize;
          this.mainOptions.limit = pageSize;
          this.queryAction();
        },
      },
      actions: [
        { type: "star-o", text: "156" },
        { type: "like-o", text: "156" },
        { type: "message", text: "2" },
      ],
    };
  },
  mounted() {
    this.queryAction();
    window.scrollTo({
      top: 0,
      behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
    });
  },

  methods: {
    to_Detail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: id,
        },
      });
    },
    queryAction() {
      axios({
        url: this.$apiUrl + "/api/general/queryMulti",
        method: "POST",
        data: this.mainOptions,
      }).then((res) => {
        this.pagination.total =
          res.data.total === undefined ? this.pagination.total : res.data.total; // 分页器条数
        let temp = res.data.data;
        console.log("res.data.data===========", temp);
        this.listData = temp;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped></style>
